import {EventListener} from "@k/global/eventVerteiler";
import {ref, watch} from "vue";
import {INTERFRAMEMESSAGES} from "@k/global/InterframeMessages";
import {UserModuleNames} from "@km/components/user/UserModulesAnimations";
import {Store} from "vuex";
import {COLORMODULE_POSSIBLE_STATES} from "@km/components/color/ModuleColorAnimationStates";
import {LOGOMODULE_POSSIBLE_STATES} from "@km/components/logo/ModuleLogoAnimationStates";
import {TabNames} from "@km/data/tabs";
import {useModuleColorOpenStateStore} from "@km/store/frontendstate/useModuleColorOpenState";
import {useModuleLogoOpenStateStore} from "@km/store/frontendstate/useModuleLogoOpenState";
import {useModuleTextOpenStatusStore} from "@km/store/frontendstate/useModuleTextOpenState";

export const vorbelegung_username = ref("");
export const login_failed = ref(false);

export const setAllTabStatesToClosed = (store:Store<any>) =>{
    useModuleTextOpenStatusStore().close();
    useModuleColorOpenStateStore().setCurrentState(COLORMODULE_POSSIBLE_STATES.closed);
    useModuleLogoOpenStateStore().setCurrentState(LOGOMODULE_POSSIBLE_STATES.closed);
    store.commit("SET_TAB_OPEN", TabNames.DESIGNS);
}


export class LoginLogoutEventListener extends EventListener {
    public constructor(store: Store<any>) {
        super();
        this.addEventListener(INTERFRAMEMESSAGES.USERMANAGEMENT_LOGIN_FAIL, (data) => {
                vorbelegung_username.value = data.login
                store.commit("OPEN_USERLAYER", UserModuleNames.login);
                login_failed.value = true;
            })
            .addEventListener(["userLoggedInEvent", "userLoggedOutEvent"], ()=>{
                setAllTabStatesToClosed(store);
            })

        watch(() => store.getters.isLoggedIn, () => {
            store.dispatch("loadLogoPool");
            store.dispatch("loadAdressen");
            store.dispatch("EntwurfListeStore/loadEntwurfListe")
            store.dispatch("loadWarenkorbUebersicht")
            login_failed.value = false;
        })
    }
}
